// Parses the "categoria: ...\nfecha: ...\n---\n# Título\n..." style blocks
// that get pasted in from externally-generated (e.g. AI) blog drafts, so the
// raw metadata lines don't end up displayed as part of the post body.

const KNOWN_KEYS = ['categoria', 'category', 'fecha', 'tags', 'meta_description'];

function stripQuotes(value) {
  return value.replace(/^["']|["']$/g, '').trim();
}

function parseTags(value) {
  return stripQuotes(value)
    .replace(/^\[|\]$/g, '')
    .split(',')
    .map((t) => stripQuotes(t.trim()))
    .filter(Boolean);
}

// Returns { meta, body } if a leading frontmatter block is detected, otherwise null.
export function parseFrontmatter(raw) {
  const lines = raw.replace(/\r\n/g, '\n').split('\n');
  let i = 0;
  while (i < lines.length && lines[i].trim() === '') i++;
  const meta = {};

  while (i < lines.length) {
    const match = lines[i].match(/^([a-zA-Z_]+):\s?(.*)$/);
    if (!match || !KNOWN_KEYS.includes(match[1].toLowerCase())) break;
    meta[match[1].toLowerCase()] = match[2];
    i++;
  }

  if (Object.keys(meta).length === 0 || lines[i]?.trim() !== '---') return null;
  i++;
  while (i < lines.length && lines[i].trim() === '') i++;

  if (meta.tags) meta.tags = parseTags(meta.tags);
  if (meta.meta_description) meta.meta_description = stripQuotes(meta.meta_description);
  if (meta.categoria) meta.category = stripQuotes(meta.categoria);
  if (meta.category) meta.category = stripQuotes(meta.category);

  return { meta, body: lines.slice(i).join('\n') };
}

// If the body's first line is a "# Heading", pulls it out as a title.
export function extractLeadingHeading(body) {
  const trimmed = body.replace(/^\n+/, '');
  const match = trimmed.match(/^#\s+(.+)\n?/);
  if (!match) return { title: null, rest: body };
  return { title: match[1].trim(), rest: trimmed.slice(match[0].length).replace(/^\n+/, '') };
}
